export interface SwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label: string
  description?: string
  disabled?: boolean
  id?: string
}

/** An on/off control with a visible label (follow live, PII flag, fake latency). */
export function Switch({ checked, onChange, label, description, disabled, id }: SwitchProps) {
  return (
    <label className={`flex items-start gap-2.5 ${disabled ? 'opacity-50' : 'cursor-pointer'}`}>
      <button
        type="button"
        id={id}
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={`relative mt-0.5 h-5 w-9 shrink-0 rounded-full transition ${checked ? 'bg-primary' : 'bg-slate-300 dark:bg-slate-600'}`}
      >
        <span
          className={`absolute top-0.5 h-4 w-4 rounded-full bg-white shadow transition ${checked ? 'left-[18px]' : 'left-0.5'}`}
        />
      </button>
      <span className="min-w-0">
        <span className="block text-xs font-medium text-default">{label}</span>
        {description && <span className="block text-2xs text-muted">{description}</span>}
      </span>
    </label>
  )
}
